/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpdateJSONWebKeySetRequestBody = {
  /**
   * The external key to back the set with from now on. Must be a live, organization-owned GCP KMS key; AWS KMS keys are not supported yet. Already-published keys are unaffected: each keeps signing with the external key it was minted from.
   */
  externalKeyId: string;
  /**
   * The ID of the key set to update.
   */
  id: string;
  /**
   * A human-readable name for the key set.
   */
  name: string;
};

/** @internal */
export type UpdateJSONWebKeySetRequestBody$Outbound = {
  external_key_id: string;
  id: string;
  name: string;
};

/** @internal */
export const UpdateJSONWebKeySetRequestBody$outboundSchema: z.ZodMiniType<
  UpdateJSONWebKeySetRequestBody$Outbound,
  UpdateJSONWebKeySetRequestBody
> = z.pipe(
  z.object({
    externalKeyId: z.string(),
    id: z.string(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      externalKeyId: "external_key_id",
    });
  }),
);

export function updateJSONWebKeySetRequestBodyToJSON(
  updateJSONWebKeySetRequestBody: UpdateJSONWebKeySetRequestBody,
): string {
  return JSON.stringify(
    UpdateJSONWebKeySetRequestBody$outboundSchema.parse(
      updateJSONWebKeySetRequestBody,
    ),
  );
}
